import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private http: HttpClient) { }

  //get CAll Log Outcome List
  getOutcomeList(userid){
    let url = devUrl + "/calllog/outcomeslist?usernumber="+userid
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('Get Call Log Outcome List', url)))
  }

  editOutcome(data){
    let url = devUrl + '/calllog/editcalllogoutcomes';
    return this.http.post(url, data).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('edit outcome for call log', url)))
  }

  createOutcome(data){
    let url = devUrl + '/calllog/createcalllogoutcome';
    return this.http.post(url, data).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('create outcome for call log', url)))
  }

  // Adding Feedback after chrome uninstallation
  giveFeedback(data){
    let url = devUrl + '/extension/feedback';
    return this.http.post(url, data).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('Add Feedback ', url)))
  }


}
